import { Directive, HostListener } from '@angular/core';

// This directive is often used to trim the space that Samsung mobiles add on autocomplete functionality

@Directive({
  selector: '[trim]'
})
export class TrimDirective {

  @HostListener('keyup', ['$event.target'])
  @HostListener('blur', ['$event.target'])
  onMouseEnter(target: HTMLInputElement) {
    target.value = (target.value || '').trim();
  }

  constructor() { }

}
